// 更新加载状态
export const UPDATE_LOADING = 'UPDATE_LOADING'
// 更新页面加载动画方向
export const UPDATE_DIRECTION = 'UPDATE_DIRECTION'
// 更新页面后退键地址
export const UPDATE_BACK_PATH = 'UPDATE_BACK_PATH'
// 更新页面来自哪里
export const UPDATE_PAGE_FROM = 'UPDATE_PAGE_FROM'
// 更新首页广告
export const UPDATE_BANNER_LIST = 'UPDATE_BANNER_LIST'
// 设置app os
export const SET_OS = 'SET_OS'
// 设置app 默认参数
export const SET_APP_PARAMS = 'SET_APP_PARAMS'
// 设置高度
export const UPDATE_INNERHEIGHT = 'UPDATE_INNERHEIGHT'

// 更新巴士列表
export const UPDATE_BUS_LIST = 'UPDATE_BUS_LIST'
// 更新当前巴士类型
export const UPDATE_CURRENT_BUS = 'UPDATE_CURRENT_BUS'
// 更新当前巴士信息
export const UPDATE_CURRENT_BUS_INFO = 'UPDATE_CURRENT_BUS_INFO'
// 更新包车下单类别
export const UPDATE_ORDER_TYPE = 'UPDATE_ORDER_TYPE'
// 更新商务用车类别
export const UPDATE_BUSINESS_TYPE = 'UPDATE_BUSINESS_TYPE'
// 更新深港互通类别
export const UPDATE_SZHK_TYPE = 'UPDATE_SZHK_TYPE'
// 更新订单出发时间
export const UPDATE_START_TIME = 'UPDATE_START_TIME'
// 更新订单返回时间
export const UPDATE_END_TIME = 'UPDATE_END_TIME'
// 更新订单包天时间
export const UPDATE_ORDER_DAY = 'UPDATE_ORDER_DAY'
// 更新包车范围
export const UPDATE_ORDER_RANGE = 'UPDATE_ORDER_RANGE'
// 更新下单巴士列表
export const UPDATE_BUS_BILL = 'UPDATE_BUS_BILL'

// 更想巴士价格
export const UPDATE_BUS_LIST_ITEM_PRICE = 'UPDATE_BUS_LIST_ITEM_PRICE'
// 更新当前位置
export const UPDATE_CURRENT_CITY = 'UPDATE_CURRENT_CITY'

// 更新下单巴士数量
export const UPDATE_BUS_BILL_NUM = 'UPDATE_BUS_BILL_NUM'
// 更新发票信息
export const UPDATE_INVOICE_INFO = 'UPDATE_INVOICE_INFO'

// 更新订单起点
export const UPDATE_START_INFO = 'UPDATE_START_INFO'
export const UPDATE_START_ADDRESS = 'UPDATE_START_ADDRESS'

// 更新订单终点
export const UPDATE_END_INFO = 'UPDATE_END_INFO'
export const UPDATE_END_ADDRESS = 'UPDATE_END_ADDRESS'

// 更新订单途径点
export const UPDATE_WAY_INFO = 'UPDATE_WAY_INFO'
export const UPDATE_WAY_ADDRESS = 'UPDATE_WAY_ADDRESS'

// 更新深港订单起点终点途径点
export const UPDATE_SZHK_START_INFO = 'UPDATE_SZHK_START_INFO'
export const UPDATE_SZHK_START_ADDRESS = 'UPDATE_SZHK_START_ADDRESS'
export const UPDATE_SZHK_END_INFO = 'UPDATE_SZHK_END_INFO'
export const UPDATE_SZHK_END_ADDRESS = 'UPDATE_SZHK_END_ADDRESS'
export const UPDATE_SZHK_WAY_INFO = 'UPDATE_SZHK_WAY_INFO'
export const UPDATE_SZHK_WAY_ADDRESS = 'UPDATE_SZHK_WAY_ADDRESS'
export const UPDATE_HK_START = 'UPDATE_HK_START'
// 更新搜索历史
export const UPDATE_HISTORY_ADDRESS = 'UPDATE_HISTORY_ADDRESS'

// 更新用户ID
export const UPDATE_USER_ID = 'UPDATE_USER_ID'
// 更新用户手机号码
export const UPDATE_USER_PHONE = 'UPDATE_USER_PHONE'
// 更新用户头像
export const UPDATE_USER_HEAD = 'UPDATE_USER_HEAD'
// 设置用户token (app only)
export const SET_USER_TOKEN = 'SET_USER_TOKEN'

// 更新用户最近选的优惠券
export const UPDATE_SELECT_COUPON = 'UPDATE_SELECT_COUPON'
// 更新最近订单价格
export const UPDATE_RECENT_PRICE = 'UPDATE_RECENT_PRICE'
// 更新最近订单总价
export const UPDATE_TOTAL_PRICE = 'UPDATE_TOTAL_PRICE'
// 清空选择车辆信息
export const RESET_SELECTED_BUS = 'RESET_SELECTED_BUS'
// 弹出窗 部分
export const UPDATE_OPEN_CITY = 'UPDATE_OPEN_CITY'
export const UPDATE_OPEN_CITY_ERROR = 'UPDATE_OPEN_CITY_ERROR'
export const UPDATE_OPEN_CITY_LIST = 'UPDATE_OPEN_CITY_LIST'
// 格式化后的，按字母排列
export const UPDATE_OPEN_CITY_LIST_FORMAT = 'UPDATE_OPEN_CITY_LIST_FORMAT'
// 两地址之间的距离
export const UPDATE_LINE_DISTANCE = 'UPDATE_LINE_DISTANCE'
// 跳转到登入页
export const JUMP_LOGIN = 'JUMP_LOGIN'
// 更新是否首次点击
export const UPDATE_IS_USED_LISTBUTTON = 'UPDATE_IS_USED_LISTBUTTON'

// 首次进入弹框显示途径点
export const UPDATE_TIPS_ADD_SITE = 'UPDATE_TIPS_ADD_SITE'

// 搜索城市定位
export const UPDATE_SELECT_OPEN_CITY = 'UPDATE_SELECT_OPEN_CITY'

// 企业id
export const UPDATE_ENTERPRISE_ID = 'UPDATE_ENTERPRISE_ID'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js